/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.57
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AuthenticationRequest model module.
 * @module model/AuthenticationRequest
 * @version 1.0.1
 */
export default class AuthenticationRequest {
  /**
   * Constructs a new <code>AuthenticationRequest</code>.
   * @alias module:model/AuthenticationRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AuthenticationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AuthenticationRequest} obj Optional instance to populate.
   * @return {module:model/AuthenticationRequest} The populated <code>AuthenticationRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AuthenticationRequest();
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} username
 */
AuthenticationRequest.prototype.username = undefined;

/**
 * @member {String} password
 */
AuthenticationRequest.prototype.password = undefined;

